import { useQuery } from "react-query";

import api from "../../../api";
import { ProfileTemplatesListResponse } from "../types";

type UseProfileTemplatesListProps = {
  teamId?: number;
};

const profileTemplatesService = async ({
  teamId,
}: UseProfileTemplatesListProps): Promise<ProfileTemplatesListResponse> => {
  const { data } = await api.get<ProfileTemplatesListResponse>(
    `/team/${teamId}/profile_templates/`,
  );
  return data;
};

export const PROFILE_TEMPLATES_QUERY_KEY = "profile-templates";

export const useProfileTemplatesList = ({
  teamId,
}: UseProfileTemplatesListProps) => {
  return useQuery<ProfileTemplatesListResponse>(
    [PROFILE_TEMPLATES_QUERY_KEY, { teamId }],
    () => profileTemplatesService({ teamId }),
    {
      enabled: teamId !== undefined,
      refetchOnWindowFocus: false,
    },
  );
};
